<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs >
        <a-tab-pane key="1" tab="购物券列表">
          <shoppingList></shoppingList>
        </a-tab-pane>
        <a-tab-pane key="2" tab="购物券统计">
          <statistics></statistics>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import shoppingList from './components/shoppingList';
import statistics from './components/statistics';
export default {
  components: {shoppingList,statistics },
  setup(props) {
    const state = reactive({

    });
    const $router = inject('$router')
    const $Modal = inject('$Modal')
    
    onMounted(() => {
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>